module.exports = require("@workbench-stack/platform-browser/lib/services/keybinding/abstract-keybinding-service");